<div class="align-content" data-cy="align-content">
    <div class="reports-header" data-cy="reports-header">
        <h2 data-cy="header-title">RELATÓRIOS DE COMISSÃO</h2>
        <div class="report-date" data-cy="report-date">
            De {{ startDate | date: "dd/MM/yyyy" }} a {{ endDate | date: "dd/MM/yyyy" }}
        </div>
    </div>

    <div *ngIf="isLoading" class="loading-spinner-container" data-cy="loading-spinner-container">
        <mat-spinner class="spinner" data-cy="loading-spinner"></mat-spinner>
    </div>

    <div *ngIf="!isLoading" class="reports-split mobile_reports-split" data-cy="reports-split">
        <div class="table-wrapper mobile_table-wrapper" data-cy="table-wrapper">
            <table class="table" data-cy="commission-table">
                <thead>
                    <tr data-cy="table-header">
                        <th data-cy="header-type">Tipo</th>
                        <th data-cy="header-value">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let commission of commissionSummary; let i = index" [attr.data-cy]="'table-row-' + i">
                        <td [attr.data-cy]="'row-type-' + i">{{ commission.type }}</td>
                        <td [attr.data-cy]="'row-value-' + i">{{ commission.value | currency: 'BRL' }}</td>
                    </tr>
                    <tr data-cy="table-row-total">
                        <td data-cy="total-label">Total</td>
                        <td data-cy="total-value">{{ aggregateSales(commissionSummary) | currency: 'BRL' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
